/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.factory('ErrorThrower', ($rootScope, ngNotify, $location) => (function(optionals_messages) {
    const messages = {
        'Unexpected Error': 'Une erreur inattendue est survenue.',
        'Not Found':        'La ressource demandée n\'existe pas',
        'Forbidden':        'La ressource demandée ne vous est pas accessible',
        'Group full':       'Il n\'y a plus de place dans votre groupe',
        'Group not found':  'Le groupe n\'existe pas'
    };

    angular.extend(messages, optionals_messages);

    return {

        messages,

        _getOneMessage(cause, messages) {
            if ((messages != null) && (messages[cause] != null)) { return messages[cause]; } else { return cause; }
        },

        // Stop the loading of the page where it was called and redirect to an error page
        // If cause is an index in this.messages, it will use this.messages[cause]as the error message
        // If not it will use cause as the error message
        major(cause, messages) {
            if (messages == null) { messages = { }; }
            angular.extend(this.messages, messages);
            const message = this._getOneMessage(cause, this.messages);
            ngNotify.set(message, 'error');
            $location.$$search = { };
            $location.path('/error');
            return $rootScope.$apply();
        },


        // Alert the user of the error but don't stop the page from loading
        // If cause is an index in this.messages, it will use this.messages[cause]as the error message
        // If not it will use cause as the error message
        minor(cause) {
            const message = this._getOneMessage(cause, this.messages);
            return ngNotify.set(message, 'error');
        }
    };
}));
